module.exports = __webpack_public_path__ + "media/research.521f0dff.mp4";